//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import * as router from "react-router-redux";
import { TreeMap, TreeFlatener, AsyncSaga } from "../../utils";
import config from "../../boot/config";
import pointservice from "../../services/points";

const initialState = {
   showSelect: true,
   selectOpen: false,
   openNodes: [],
   
   isBusy: false,
   errors: [],
   hasError: false
};

/////////
//types
export const types = {
   TOGGLE_HIDE_SELECT: "components/header/TOGGLE_HIDE_SELECT",
   OPEN_SELECT: "components/header/OPEN_SELECT",
   CLOSE_SELECT: "components/header/CLOSE_SELECT",
   TOGGLE_NODE: "components/header/TOGGLE_NODE",
};

///////////
//reducers
export const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {
      case types.TOGGLE_HIDE_SELECT:
            return { ...state, showSelect: action.payload };
      case types.OPEN_SELECT:{
                  return {...state, selectOpen: true}
            }
      case types.CLOSE_SELECT: {
            return {...state, selectOpen: false};
      }
      case types.TOGGLE_NODE:{
            if(state.openNodes.indexOf(action.payload.nodePath) === -1){
                  return {...state, openNodes: state.openNodes.concat(action.payload.nodePath)};
            }else{
                  return {...state, openNodes: state.openNodes.filter(node => node !== action.payload.nodePath)};
            }
      }
         default:
            return state;
      }
   }
};

//////////
//sagas
export const sagas = {
   *rootSaga() {
      yield all([]);
   },
};

////////
//actions
export const actions = {
   toggleHeaderSelect(payload) {
      return {
         type: types.TOGGLE_HIDE_SELECT,
         payload
      };
   },
   openSelect(){
         return {
               type: types.OPEN_SELECT,
               payload: {}
         };
   },
   closeSelect(){
         return {
               type: types.CLOSE_SELECT,
               payload: {}
         };
   },
   toggleNode(nodePath){
         return {
               type: types.TOGGLE_NODE,
               payload: {nodePath}
         };
   }
};



// WEBPACK FOOTER //
// ./src/components/Header/redux.js